import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const AdminPanel = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-blue-500 hover:text-blue-600 mb-8"
        >
          <ArrowLeft size={20} />
          Back to Portfolio
        </Link>
        
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h1 className="text-4xl font-bold mb-4">
            <span className="text-blue-500">Admin</span>{' '}
            <span className="text-green-500">Panel</span>
          </h1>
          <p className="text-gray-600 text-lg mb-8">
            Backend integration in progress. Full admin panel with editing capabilities coming soon!
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-6">
              <h3 className="text-xl font-bold text-blue-600 mb-2">Personal Info</h3>
              <p className="text-gray-600 text-sm">Edit your name, title, contact details</p>
            </div>
            
            <div className="bg-red-50 border-2 border-red-200 rounded-xl p-6">
              <h3 className="text-xl font-bold text-red-600 mb-2">Experience</h3>
              <p className="text-gray-600 text-sm">Add, edit, delete work experience</p>
            </div>
            
            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6">
              <h3 className="text-xl font-bold text-green-600 mb-2">Projects</h3>
              <p className="text-gray-600 text-sm">Manage projects and flowcharts</p>
            </div>
            
            <div className="bg-yellow-50 border-2 border-yellow-200 rounded-xl p-6">
              <h3 className="text-xl font-bold text-yellow-600 mb-2">Skills</h3>
              <p className="text-gray-600 text-sm">Update your technical skills</p>
            </div>
            
            <div className="bg-purple-50 border-2 border-purple-200 rounded-xl p-6">
              <h3 className="text-xl font-bold text-purple-600 mb-2">Contact Messages</h3>
              <p className="text-gray-600 text-sm">View messages from visitors</p>
            </div>
            
            <div className="bg-indigo-50 border-2 border-indigo-200 rounded-xl p-6">
              <h3 className="text-xl font-bold text-indigo-600 mb-2">Settings</h3>
              <p className="text-gray-600 text-sm">Configure portfolio settings</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
